<script setup lang="ts">
    import { inject } from 'vue';
    import { FeatureService } from '@shared/directives/Feature.service';
    import { injectorAccessInjectionKey } from '@cwd/lib/provider-keys';

    const props = defineProps<{
        currentRouteName: string | null;
    }>();

    const injectorAccess = inject(injectorAccessInjectionKey)!;
    const featureAccess: FeatureService = injectorAccess.injector.get(FeatureService);
</script>

<template>
    <nav
        v-show="
            currentRouteName !== 'ResponseContact' &&
            currentRouteName !== 'TextMessageSending' &&
            currentRouteName !== 'NewTextMessage' &&
            currentRouteName !== 'TextMessageStatistics' &&
            currentRouteName !== 'TextMessageStatisticsContacts' &&
            currentRouteName !== 'TextMessageStatisticsContact'
        "
        class="p-sm-t p-lg-r p-lg-l">
        <ul class="navbar-tabs list-unstyled d-inline-flex" role="tablist">
            <li :class="currentRouteName === 'TextMessages' && 'active'">
                <router-link :to="{ name: 'TextMessages' }">
                    {{ $Resources.SmsMenuItem }}
                </router-link>
            </li>
            <li :class="currentRouteName === 'TextMessagesResponses' && 'active'">
                <router-link :to="{ name: 'TextMessagesResponses' }">
                    {{ $Resources.SmsLastResponsesRecievedTab }}
                </router-link>
            </li>
            <li :class="currentRouteName === 'SmsDialogs' && 'active'" v-if="featureAccess.hasFeature('SmsDialog')">
                <router-link :to="{ name: 'SmsDialogs' }">
                    {{ $Resources.SmsDialogsTab }}
                </router-link>
            </li>
            <li :class="currentRouteName === 'TextMessagesKeywords' && 'active'">
                <router-link :to="{ name: 'TextMessagesKeywords' }">
                    {{ $Resources.SmsKeywordsMenuLabel }}
                </router-link>
            </li>
        </ul>
    </nav>
</template>
